import api from './api';

const featureCommentService = {
  async getComments(featureSlug) {
    const response = await api.get(`/api/features/${featureSlug}/comments`);
    return response.data;
  },

  async createComment(featureSlug, { content, parentId = null }) {
    const response = await api.post(`/api/features/${featureSlug}/comments`, {
      content,
      parentId,
    });
    return response.data;
  },

  async moderateComment(commentId, status) {
    const response = await api.patch(`/api/features/comments/${commentId}/moderation`, { status });
    return response.data;
  },

  async deleteComment(commentId) {
    const response = await api.delete(`/api/features/comments/${commentId}`);
    return response.data;
  },
};

export function buildCommentTree(comments) {
  const byId = new Map();
  const roots = [];

  comments.forEach((comment) => {
    byId.set(comment.id, { ...comment, replies: [] });
  });

  byId.forEach((comment) => {
    if (comment.parentId && byId.has(comment.parentId)) {
      byId.get(comment.parentId).replies.push(comment);
    } else {
      roots.push(comment);
    }
  });

  return roots;
}

export default featureCommentService;
